import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {HttpClient} from "@angular/common/http";
import {CommonTransformationService} from "./common-transformation.service";
import {QueryResult} from "@app/shared";

@Injectable()
export class RecruitingService {

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  getJobReqInfo(): Observable<any> {
    let url = `/recruiting/job-reqs/info?start=0&count=-1`;
    return this.http.get(url);
  }

  getJobReqInfoAsDropdown(): Observable<any> {
    return this.getJobReqInfo().pipe(map(res => {
      return this.transform.convertToDropDown("postedJobTitle", res.list, "id");
    }));
  }

  getScreeningQuestionCategories(name?: string): Observable<QueryResult> {
    let url = `/recruiting/screening-question-categories/search?start=0&count=-1`;

    if (name) {
      url += `&name=${name}`;
    }
    return this.http.get<QueryResult>(url);
  }

  getScreeningQuestionCategoriesAsDropdown(name?: string): Observable<any> {
    return this.getScreeningQuestionCategories(name).pipe(map(res => {
      return this.transform.convertToDropDown("name", res.list, "id", true);
    }));
  }


  getScreeningQuestions(name?: string): Observable<QueryResult> {
    let url = `/recruiting/screening-questions/search?start=0&count=-1`;

    if (name) {
      url += `&name=${name}`;
    }
    return this.http.get<QueryResult>(url);
  }
}
